export default {"src":"/_next/static/media/pinterest-icon.ba2c7802.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};